import { useMutation } from 'react-query';

import { createOrUpdateCardComment as mutationFn } from 'api/endPoints/createOrUpdateCardComment';

import { IComment } from 'components/Dashboards/Program/Dashboard/ProgramDashboardComponents/Battlecards/battlecards.types';

export const useMutationCreateEditComment = () => {
    return useMutation<IComment, QueryError, ICreateEditCommentPayload>((params) => mutationFn(params));
};

export interface ICreateEditCommentPayload {
    cardId: number | undefined;
    comment: string;
    id: number | null;
    mentionedList: string[];
    isVirtual: boolean;
}
